import createNamedContext from 'utils/createNamedContext';

export interface MultitabRouterContextValue {
  pathname: string;
  search: string;
  state?: any;
  params: object;
}

export const MultitabRouterContext = createNamedContext<MultitabRouterContextValue | null>(
  'MultitabRouterContext',
  null,
);

export interface OutletContextValue {
  outlet: JSX.Element;
}

export const OutletContext = createNamedContext<OutletContextValue | null>('OutletContext', null);
